import { isEmptyObject } from "../../../utils/tests";
import { TeamPlayersQuery } from '../types';

/**
 * typeguard for TeamPlayersQuery
 * @param TeamPlayersQuery object passed to transformer
 */
export const isValidTeamPlayers = (obj: TeamPlayersQuery): boolean => Boolean(obj?.data?.getTeamPlayers && !isEmptyObject(obj.data.getTeamPlayers));
